<template>
  <div class="nav-cloth-container">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item v-for="c in classfications" :key="c" :index="c">{{ c }}</el-menu-item>
    </el-menu>

    <div class="exhibition">
      <div class="cloth-grid">
        <div class="cloth-item" v-for="(item, index) in clothList" :key="index" v-show="item.url">
          <p class="cloth-title">{{ item.category }}</p>
          <img :src="resolveUrl(item.url)" class="cloth-img" @click="goToPage"/>
        </div>
      </div>
      
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="6"
          layout="total, prev, pager, next"
          :total="sumData">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { findBypaging, getClassfications } from '@/api/product'

export default {
  data() {
    return {
      sumData: 0,
      currentPage: 1,
      activeIndex: '',
      classfications: [],
      pageparam: {
        pagenum: 1,
        pagesize: 6,
        classfication: ''
      },
      clothList: [
        { url: null, category: null },
        { url: null, category: null },
        { url: null, category: null },
        { url: null, category: null },
        { url: null, category: null },
        { url: null, category: null }
      ],
    };
  },
  methods: {
    resolveUrl(u) {
      if (!u) return ''
      if (/^https?:\/\//i.test(u)) return u
      const base = (process.env.VUE_APP_API_BASE_URL || 'http://localhost:8081').replace(/\/$/, '')
      const path = String(u).trim().replace(/\\/g, '/').replace(/^\/+/, '')
      return `${base}/${path}`
    },
    goToPage() {
      this.$router.push('/product').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    load() {
      findBypaging(this.pageparam).then((res) => {
        this.sumData = res.data.sumData
        const list = res.data.res
        for (let i = 0; i < this.clothList.length; i++) {
          if (i >= list.length) {
            this.clothList[i].category = null
            this.clothList[i].url = null
          } else {
            this.clothList[i].category = list[i].category
            this.clothList[i].url = list[i].url
          }
        }
      })
    },
    handleSelect(key) {
      this.pageparam.classfication = key;
      this.pageparam.pagenum = 1; // 切换分类时应该重置页码！这是一个修复点
      this.currentPage = 1;
      this.load()
    },
    handleSizeChange(val) {
      this.pageparam.pagesize = val;
      this.pageparam.pagenum = 1;
      this.currentPage = 1;
      this.load();
    },
    handleCurrentChange(val) {
      this.pageparam.pagenum = val;
      this.load()
    }
  },
  created() {
    (async () => {
      try {
        const res = await getClassfications()
        this.classfications = (res && res.data) ? res.data : []
      } catch (e) {
        this.classfications = []
      }
      this.activeIndex = this.classfications[0] || 'polo衫'
      this.pageparam.classfication = this.activeIndex
      this.load()
    })()
  }
}
</script>

<style scoped>
.nav-cloth-container {
  width: 100%;
}
.exhibition {
  padding: 20px 0;
  width: 100%;
}
.cloth-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}
.cloth-item {
  width: calc(33.333% - 15px);
  min-width: 200px; /* 大小自适应，保证手机端换行 */
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.cloth-title {
  color: #303133;
  font-weight: 600;
  margin-bottom: 12px;
  font-size: 16px;
}
.cloth-img {
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, box-shadow 0.3s;
}
.cloth-img:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.Pagination {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

@media (max-width: 768px) {
  .cloth-item {
    width: calc(50% - 15px);
  }
  .el-menu--horizontal {
    white-space: nowrap;
    overflow-x: auto;
  }
}
@media (max-width: 480px) {
  .cloth-item {
    width: 100%;
  }
}
</style>